export default __webpack_public_path__ + "assets/images/ef39be657328473fac8b15be7240c278.svg";